const Driver = {
    mandatoryHeader: {
      'Mobile Number': 'mobile_number',
      'transporter Reference Id': 'transporter_ref_id',
    },
    optionalHeader: {
      'Driver Name': 'driver_name',
      'Status': 'status',
      'License Number': 'license_number',
      'Medical Start Date': 'medical_start_date',
      'medical_end_date': 'medical_end_date',
    },
  };
  
  module.exports = { Driver };
  